import { sanitize } from "dompurify";
import "../css/NewsItem.css"

export default function NewsItem(props) {
  const featuredImg = props.post._embedded["wp:featuredmedia"][0].source_url;
  const link = `/vijest/${props.post.slug}`;
  const title = props.post.title.rendered;
  const category = "RAZNO";
  var divStyle = {
    backgroundImage: `url(${featuredImg})`,
  };
  return (
    <a href={link}>
      <div style={divStyle} className="NewsItem">
        <div className="itemCategory">{category}</div>
        <div className="itemTitle" dangerouslySetInnerHTML={{__html: sanitize(title)}}></div>
      </div>
    </a>
  );
}